import React from 'react';
import { UALProvider } from 'ual-reactjs-renderer';
import {Helmet} from "react-helmet";
import { anchor, wax, myChain, currentWebsiteURL,  wombat, APP_NAME, CONTRACT_NAME, IMAGE_DIR } from '../data/config';
import "./homepage-styles.css"
import { NewListingBody, NewListingCont, TallFiltersCont, TallFiltersInnerCont, theme } from '../Styles';

const FAQ = () => {

  return (
  <div id="seo">
    <Helmet>
    <title>FAQ - WaxDAO Names</title>
    <meta name="description" content="Frequently asked questions - WaxDAO name service" />
    <link rel="canonical" href={`${currentWebsiteURL}/faq`} />
    </Helmet>

    <UALProvider chains={[myChain]} authenticators={[anchor, wax, wombat]} appName={APP_NAME}>

    <NewListingCont>
        <NewListingBody>
            <TallFiltersCont>
                <h2>FAQ</h2>
            </TallFiltersCont>
            <br/>
            <TallFiltersCont>
                <h2>What is the point of this site?</h2>
                <br/>
                <TallFiltersInnerCont>
                    WaxDAO Names is a place where you can buy and sell custom WAX account names. If you are{" "}
                    unfamiliar with how custom names work on WAX, here's a quick breakdown:
                    <br/><br/>
                    Normally, any WAX account you create needs to be 12 characters. However, you can buy a shorter name (a.k.a){" "}
                    a "premium" name, by bidding on a name using waxblock.io
                    <br/><br/>
                    If you own a name that is shorter than 12 characters, you can create custom names that end in ".your_custom_name"
                    <br/><br/>
                    For example, if you own the name com, you can create names like mike.com or wax.com 
                    <br/><br/>
                    Using our website, you can also sell these custom names to people - all you need to do is own a premium name, and then you can list it for sale.{" "}
                    If you're just looking to buy - look no further. You can buy a custom name on our listings page.
                </TallFiltersInnerCont>
            </TallFiltersCont>

            <TallFiltersCont>
                <h2>What is the listing fee?</h2>
                <br/>
                <TallFiltersInnerCont>
                This is based on how many listings you have open at one time - it is there to prevent people from spamming 1000 listings.
                <br/><br/>
                Your first listing costs 1 WAX. If you keep that listing open, and try to create another listing without cancelling the first listing beforehand, 
                then the 2nd listing will cost 2 WAX. Third one will cost 3 WAX, etc.
                <br/><br/>
                Again, this is based on <b>open</b> listing count. So, if you cancel all your open listings, then you can create a new one for only 1 WAX.
                <br/><br/>
                It is worth noting that this open listing count only applies to the name you are listing. If you have 10 names to list, you can log in separately with those 10 different accounts - and each listing will only cost you 1 WAX.
                </TallFiltersInnerCont>
            </TallFiltersCont>

            <TallFiltersCont>
                <h2>I have questions about giving WaxDAO authorization/permission on my account.</h2>
                <br/>
                <TallFiltersInnerCont>
                Totally understandable. Here's how it works:
                <br/><br/>
                Only the owner of an account can create custom names for that account. UNLESS of course, you give someone else permission to create names.
                <br/><br/>
                If you want to list your name on WaxDAO, then we need permission to create names for you - or else people will not be able to buy your listing.
                <br/><br/>
                Here's what we can do with this permission that you are granting us: <b>create names.</b>
                <br/><br/>
                Here's what we can NOT do with this permission that you are granting us: <b>everything else.</b>
                <br/><br/>
                We can not access funds in your wallet, we can not make transfers, etc. The ONLY thing that we can do is create names.
                <br/><br/>
                <b><i>NOTE: you must have "Allow Dangerous Transactions" setting enabled in Anchor wallet to give us the authorization we need.</i></b>
                </TallFiltersInnerCont>
            </TallFiltersCont>    

            <TallFiltersCont>
                <h2>Who pays the cost for newly created accounts?</h2>
                <br/>
                <TallFiltersInnerCont>
                The cost for an account to be created is 5 WAX, and that WAX gets debited from the balance that you store on our contract.
                <br/><br/>
                This means that you need to deposit WAX to our contract in order to cover account creation fees; However, there is a much better solution.
                <br/><br/>
                When you create your listing, you can enter 5 WAX as one of the fungible ingredients for your listing. Then, enter <span style={{color: theme.secondary}}>{CONTRACT_NAME}</span> as the receiver,{" "}
                and any purchases will be applied directly to your balance. 5 WAX will be enough to cover account creation, so you'll never need to worry about topping up!
                </TallFiltersInnerCont>
            </TallFiltersCont>      

            <TallFiltersCont>
                <h2>I am getting an error when trying to add the permissions. Is there any other way to do it?</h2>
                <br/>
                <TallFiltersInnerCont>
                If you're having issues adding the permission through our website, one other option is to try and do it through <a href={"https://waxblock.io"} target="none">waxblock.io</a>
                <br/><br/>
                Please follow these instructions very carefully, as any mistakes can lead to this not working properly.
                <br/><br/>
                <b>Step 1:</b>Go to the <a href="https://waxblock.io/wallet/permissions/advanced" target="none">advanced permissions section of waxblock</a> (make sure you are logged in!)
                <br/><br/>
                The screen should look like this:<br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/1.png`} />
                <br/>
                You will want to click the <span style={{color: theme.secondary}}>"Add New +"</span> button TWO times.
                <br/><br/>
                The screen should now look like this:<br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/2.png`} />
                <br/>
                If you followed the instructions correctly so far, there should be THREE rows of information to fill out.
                <br/><br/>
                In the first row, enter <span style={{color: theme.secondary, fontWeight:"bold"}}>newaccount</span> for the permission name, and <span style={{color: theme.secondary, fontWeight:"bold"}}>active</span> for the "Parent" field.
                It should look like this now:<br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/3.png`} />
                <br/>
                In the second row, the only thing you need to do is enter <span style={{color: theme.secondary, fontWeight:"bold"}}>EOS7QK6aXXScbRRrfb9LaPfZKy8BU6FUmsn2HaXG5tVJMw4Cv6ZV1</span> as the public key. It should look like this now:<br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/4.png`} />
                <br/>
                In the third row, you need to change TWO things. First, under the "Type" field, select <span style={{color: theme.secondary, fontWeight:"bold"}}>Account</span> from the drop down menu.<br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/5.png`} />
                <br/>
                Then, enter <span style={{color: theme.secondary, fontWeight:"bold"}}>names.waxdao@eosio.code</span> under the "Actor@permission" field:<br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/6.png`} />
                <br/>
                If everything looks good, you can now click the <span style={{color: theme.secondary, fontWeight:"bold"}}>Add New Permission</span> button and sign the transaction. (NOTE: Some wallets will not let you change permissions unless you have a special setting configured in your wallet. For example, Anchor wallet requires you to have "Allow Dangerous Transactions" setting enabled.)
                <br/><br/>
                <span className='text-xl font-bold'>You're Almost There, But Not Done Yet!</span>
                <br/><br/>
                Once you have signed the transaction and added the permission to your account, there is one more thing you need to do: Link the permission (this is basically telling the blockchain, "Hey! This new permission is only allowed to do ONE thing: Create new accounts!")
                <br/><br/>
                "But how do I link the permission, Mike?"
                <br/><br/>
                Easy. Go to the <a href="https://waxblock.io/wallet/permissions/link-auth" target="none">Link Auth page on WaxBlock</a>
                <br/><br/>
                It should look like this:<br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/7.png`} />
                <br/>
                Select <span style={{color: theme.secondary, fontWeight:"bold"}}>newaccount</span> from the drop down menu under where it says "Permission" (You might need to refresh the page to get the newaccount permission to show up in the list)
                <br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/8.png`} />
                <br/>
                Now, under "Contract Name", enter <span style={{color: theme.secondary, fontWeight:"bold"}}>eosio</span>
                <br/><br/>
                Under "Contract Action", select <span style={{color: theme.secondary, fontWeight:"bold"}}>newaccount</span>
                <br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/9.png`} />
                <br/>
                Now, all you need to do is click the big <span style={{color: theme.secondary, fontWeight:"bold"}}>LINK AUTH</span> button, and sign the transaction.
                <br/><br/>
                If everything worked properly, you should be able to go to your <a href="https://waxblock.io/account/warc#keys" target="none">keys page on waxblock</a> and see a key that looks exactly like this:<br/>
                <img src={`${IMAGE_DIR}/name-service-permissions/10.png`} />
                <br/>
                That's it! You're ready to go <a href={`${currentWebsiteURL}/sell`}>create your listing</a> - what are you waiting for?!
                </TallFiltersInnerCont>
            </TallFiltersCont>                            

        </NewListingBody>
    </NewListingCont>







    </UALProvider>
    <br/><br/><br/>
    </div>
  )
}

export default FAQ